import { createSlice } from '@reduxjs/toolkit';
import { IUserState } from '../../../types/referral/user';

const initialState: IUserState = {};

const referralUserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setReferralUserPhoneNumber(state, action) {
      state.phoneNumber = action.payload;
    },
  },
});

export const {
  reducer: referralUserReducer,
  actions: { setReferralUserPhoneNumber },
} = referralUserSlice;
